<template>
    <b-modal
        id="assignment-show-partner-modal"
        :title="$t('assignment.collaboration_group')"
        modal-class="apprentice-default-modal"
        size="lg"
        ok-only
        :ok-title="$t('common.close')">
        <ul v-if="assignmentCooperationIn.coop_maker_type === 'student'">
            <li v-if="assignmentCooperationIn.minimum > 1">
                {{
                    $t('assignment.minimum_group_size_including_yourself', {
                        size: assignmentCooperationIn.minimum,
                    })
                }}
                <!--TODO-->
                {{ assignmentCooperationIn.minimum }}
                Minimale groepsgrootte: {{ assignmentCooperationIn.minimum }} (inclusief jezelf)
            </li>
            <li v-if="assignmentCooperationIn.maximum > 1">
                {{
                    $t('assignment.maximum_group_size_including_yourself', {
                        size: assignmentCooperationIn.minimum,
                    })
                }}
                Maximale groepsgrootte: {{ assignmentCooperationIn.maximum }} (inclusief jezelf)
            </li>
        </ul>
        <design-2021-apprentice-data-table
            class="selected-students-status-overview-table"
            :items="assignmentPartnerIn.assignment_partner_users"
            :fields="fields">
            <template v-slot:options>
                <b-button
                    class="btn-add-student btn-user-add"
                    v-if="
                        (!maxReached && assignmentCooperationIn.coop_maker_type === 'student') ||
                        $authUser.isAdmin() ||
                        $authUser.isTeacher()
                    "
                    v-b-modal="'assignment-show-partner-add-modal'"
                    variant="primary">
                </b-button>
            </template>

            <template
                v-slot:cell(status)="data"
                v-if="assignmentCooperationIn.coop_maker_type === 'student'">
                <div class="partner-user-status">
                    <b-badge :variant="data.item.confirmed ? 'success' : 'warning'">
                        {{ data.item.confirmed ? $t('assignment.accepted') : $t('assignment.waiting') }}
                    </b-badge>
                </div>
            </template>

            <template v-slot:cell(actions)="data">
                <div class="partner-user-actions">
                    <b-button
                        class="btn-remove btn-remove-student"
                        v-if="
                            (assignmentPartnerIn.user_id === $authUser.id &&
                                assignmentCooperationIn.coop_maker_type === 'student' &&
                                data.item.user_id !== $authUser.id &&
                                !data.item.confirmed &&
                                !minReached) ||
                            !$authUser.isStudent()
                        "
                        variant="danger-icon"
                        @click="removeUser(data.item)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-assignment-show-partner-add-modal-component
            :assignment-partner-in="assignmentPartnerIn"
            :assignment-cooperation-in="assignmentCooperationIn"
            :amount-in="assignmentPartnerIn.assignment_partner_users.length"
            :group-id-in="groupIdIn">
        </design-2021-assignment-show-partner-add-modal-component>
    </b-modal>
</template>

<script>
import { ords } from '../../../../app';

export default {
    name: 'design-2021-assignment-show-partner-modal-component',
    props: {
        assignmentPartnerIn: Object,
        groupIdIn: Number,
        assignmentCooperationIn: Object,
    },
    data() {
        return {};
    },
    computed: {
        fields() {
            let fields = [
                {
                    key: 'user.full_name',
                    label: this.$t('assignment.student'),
                    sortable: true,
                },
            ];

            if (this.assignmentCooperationIn.coop_maker_type === 'student') {
                fields.push({
                    key: 'status',
                    label: 'Status',
                });
            }

            if (
                (this.assignmentPartnerIn.user_id === this.$authUser.id &&
                    this.assignmentCooperationIn.coop_maker_type === 'student') ||
                !this.$authUser.isStudent()
            ) {
                fields.push({
                    key: 'actions',
                    label: this.$t('common.actions'),
                });
            }

            return fields;
        },

        maxReached() {
            let maxreached =
                this.assignmentPartnerIn.assignment_partner_users.length >= this.assignmentCooperationIn.maximum &&
                this.assignmentCooperationIn.maximum;
            if (maxreached && this.$authUser.isStudent()) {
                this.$bvModal.hide('assignment-show-partner-add-modal');
            }
            return maxreached;
        },
        minReached() {
            return (
                this.assignmentPartnerIn.assignment_partner_users.length <= this.assignmentCooperationIn.minimum &&
                this.assignmentCooperationIn.minimum
            );
        },
    },
    methods: {
        removeUser(assignmentPartnerUser) {
            this.alert
                .confirm(
                    this.$t('assignment.delete_request'),
                    this.$t('assignment.are_you_sure_you_want_to_delete_this_request'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();
                    this.axios.delete(this.routes.assignmentPartnerUserRemove(assignmentPartnerUser.id)).then(
                        (response) => {
                            ords.hold();
                            assignmentPartnerUser.detach('user', assignmentPartnerUser.user_id); // this shouldn't be necessary
                            assignmentPartnerUser.remove();
                            ords.continue();
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        addPartner(data) {
            this.$emit('addPartner', data);
        },
    },
};
</script>

<style scoped lang="scss">
.btn-add-student {
    font-size: $default-font-size;
    line-height: 1.5;
    padding: map-get($grid-gutter-spacing, 'eight');
    align-self: center;
}

.selected-students-status-overview-table ::v-deep {
    table tbody {
        .btn-remove-student {
            font-size: $default-font-size;
        }
    }
}
</style>
